import privateRoutes from '../PrivateRoutes';
import { publicPaths } from '../paths/publicPaths';

export function getFirstAccessibleRoute(
  hasAnyPermission: (permissions: string[]) => boolean,
): string {
  for (const route of privateRoutes) {
    const perms = route.permissions ?? [];
    if (perms.length === 0 || hasAnyPermission(perms)) {
      return route.path;
    }
  }
  return publicPaths.UNAUTHORIZED;
}
